import React from "react";
import { useTranslation } from "react-i18next";
import { StyledPortfolio } from "../components/Styles";
import Consultation from "../components/Consultation";
import LinkedinIcon from "../components/Icons/Linkedin";
import EmailIcon from "../components/Icons/Email";
import { Link } from "react-router-dom";

import About from "../components/Styles/assets/aboutus.webp";
import getProjectImage from "../utils/getProjectImage";


const Portfolio = () => {
    const { i18n, t } = useTranslation();


    const projects = t("projects.items", { returnObjects: true });
    console.log(projects)


    return (
        <StyledPortfolio.Container>
            <StyledPortfolio.Content>
                <StyledPortfolio.ShapeTopLeft lang={i18n.language}>
                    <img src={About} alt={t("portfolio.alt")} />
                </StyledPortfolio.ShapeTopLeft>

                <StyledPortfolio.Title>
                    <span>{t("portfolio.titleSpan")}</span>
                    {t("portfolio.title")}
                </StyledPortfolio.Title>

                <StyledPortfolio.Description>
                    {t("portfolio.description")}
                </StyledPortfolio.Description>
            </StyledPortfolio.Content>

            <StyledPortfolio.H3 lang={i18n.language}>{t("projects.title")}</StyledPortfolio.H3>

            <StyledPortfolio.Projects>
                {projects.map((project, idx) => (
                    <StyledPortfolio.Card key={idx}>
                        {/* <StyledPortfolio.Thumbnail>
                            <a href={project.link} target="_blank" rel="noopener noreferrer">
                                <img
                                    src={`https://api.microlink.io/?url=${project.link}&screenshot=true&meta=false&embed=screenshot.url`}
                                    alt={project.title}
                                />
                            </a>
                        </StyledPortfolio.Thumbnail> */}
                        <StyledPortfolio.Thumbnail>
                            <a
                                href={project.link}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <img
                                    src={getProjectImage(project.link)}
                                    alt={project.title}
                                    onError={(e) => {
                                        e.target.src = "/screenshots/placeholder.webp";
                                    }}
                                />
                            </a>
                        </StyledPortfolio.Thumbnail>

                        <StyledPortfolio.CardContent>
                            <StyledPortfolio.CardTitle>
                                <a href={project.link} target="_blank">{project.title}</a>
                            </StyledPortfolio.CardTitle>

                            <StyledPortfolio.Footer>
                                <span>{project.year}</span>
                            </StyledPortfolio.Footer>
                        </StyledPortfolio.CardContent>
                    </StyledPortfolio.Card>
                ))}
            </StyledPortfolio.Projects>

            <Consultation />
        </StyledPortfolio.Container>
    );
};

export default Portfolio;